import React, { useCallback } from 'react'
import { Loading } from 'components/Loading'
import { useApiClient } from 'utils/api/ApiClient'
import { useFetchOne } from 'utils/api/useFetch'
import { WalletsApiClient } from 'utils/api/walletsApiClient'

import { UploadTransactionHistoryTable } from './UploadTransactionHistoryTable'

interface Props {
  historyId: string
}
export const UploadTransactionHistoryPage: React.FC<Props> = ({ historyId }) => {
  const walletsApiClient = useApiClient(WalletsApiClient)
  const statisticsFetchData = useCallback(
    () => walletsApiClient.getTradingAccountAdjustmentHistoryUpload(historyId),
    [historyId] // eslint-disable-line react-hooks/exhaustive-deps
  )
  const { data, isLoading } = useFetchOne(statisticsFetchData)

  return (
    <Loading isLoading={isLoading} modalView>
      {data && <UploadTransactionHistoryTable data={data} />}
    </Loading>
  )
}
